import { t } from '@avalara/bat-apps-shared/i18n';
import { SIcon } from '@avalara/skylab-sdk/react';
import { CheckItem } from '../../../shared/accordion-styled-components';
import { GrayBackground } from '../../styled/thank-you';

const IossMiddleContent = () => (
  <GrayBackground className='text-center pad-all-lg'>
    <h3>{"Information you'll need to set up your IOSS Solution"}</h3>
    <div style={{ display: 'inline-block' }}>
      <CheckItem className='margin-top-md'>
        <SIcon name='check' />
        <span>{t('client.general.details-regarding-the-activities-your-business-is-conducting')}</span>
      </CheckItem>

      <CheckItem>
        <SIcon name='check' />
        <span>{t('client.general.your-vat-numbers-if-you-already-have-any')}</span>
      </CheckItem>

      <CheckItem>
        <SIcon name='check' />
        <span>{"Details for the bank account you'll use to pay your VAT"}</span>
      </CheckItem>
    </div>
  </GrayBackground>
);
export default IossMiddleContent;
